/**
 * @file 模型库页常量
 * @author FengGuang(fengguang01@baidu.com)
 */
import {IModelBaseMenu} from './type';

// 热门模型的数据，由前端写死而不是后端返回
export const MODEL_BASE_MENU_HOT: IModelBaseMenu = {
    id: '\n',
    name: '热门模型',
    parentId: '',
    isHot: true,
    children: []
};

